/** Phase 12 (FAM-03): shown above the visit summary field in charting. */
export const GUARDIAN_SUMMARY_NOTE = 'Approved guardians can read this summary.';
